import { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { base44 } from "@/api/base44Client";
import { Card } from "@/components/ui/card";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Settings, Bell, LayoutDashboard, User, KeyRound } from "lucide-react";
import NotificationPreferences from "@/components/settings/NotificationPreferences";
import DashboardSettings from "@/components/settings/DashboardSettings";
import ProfileSettings from "@/components/settings/ProfileSettings";
import SecuritySettings from "@/components/settings/SecuritySettings";

export default function UserSettings() {
  const { data: user, isLoading } = useQuery({
    queryKey: ["currentUser"],
    queryFn: () => base44.auth.me(),
  });

  return (
    <div className="min-h-screen bg-slate-50">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        {/* Header */}
        <div className="mb-8">
          <div className="flex items-center gap-3 mb-2">
            <div className="w-12 h-12 rounded-xl bg-gradient-to-br from-zinc-900 to-zinc-900 flex items-center justify-center">
              <Settings className="w-6 h-6 text-white" />
            </div>
            <div>
              <h1 className="text-3xl font-bold text-slate-900 tracking-tight">Brukerinnstillinger</h1>
              <p className="text-slate-500 mt-1">Tilpass din opplevelse</p>
            </div>
          </div>
        </div>

        {isLoading ? (
          <div className="space-y-6">
            <div className="h-96 bg-white rounded-xl animate-pulse" />
          </div>
        ) : (
          <Tabs defaultValue="profile" className="space-y-6">
            <TabsList className="bg-white border border-slate-200 p-1">
              <TabsTrigger value="profile" className="gap-2">
                <User className="w-4 h-4" />
                Profil & Valuta
              </TabsTrigger>
              <TabsTrigger value="notifications" className="gap-2">
                <Bell className="w-4 h-4" />
                Varsler
              </TabsTrigger>
              <TabsTrigger value="security" className="gap-2" data-testid="tab-security">
                <KeyRound className="w-4 h-4" />
                Sikkerhet
              </TabsTrigger>
              <TabsTrigger value="dashboard" className="gap-2">
                <LayoutDashboard className="w-4 h-4" />
                Dashboard
              </TabsTrigger>
            </TabsList>

            <TabsContent value="profile">
              <ProfileSettings user={user} />
            </TabsContent>

            <TabsContent value="notifications">
              <NotificationPreferences user={user} />
            </TabsContent>

            <TabsContent value="security">
              <SecuritySettings user={user} />
            </TabsContent>

            <TabsContent value="dashboard">
              <DashboardSettings user={user} />
            </TabsContent>
          </Tabs>
        )}
      </div>
    </div>
  );
}